/**
 * Utility to combine the Apps Services into a single DI point to manage complex DI chains in App Components and Services.
 *
 * @export
 * @class AppServices
 */
export class AppServices {
  public static $inject: [string] = ['$log', 'DevTools', 'FullscreenManager', 'UserAgentManager', 'AudioManager', 'ScreenManager', 'TransitionManager', 'PixiManager', 'LocalStorageManager', 'DataManager', 'ColorManager', 'ModalManager', 'HeroManager', 'CarouselManager', 'ProgressManager']

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(
    public $log: any,
    public DevTools: any,
    public FullscreenManager: any,
    public UserAgentManager: any,
    public AudioManager: any,
    public ScreenManager: any,
    public TransitionManager: any,
    public PixiManager: any,
    public LocalStorageManager: any,
    public DataManager: any,
    public ColorManager: any,
    public ModalManager: any,
    public HeroManager: any,
    public CarouselManager: any,
    public ProgressManager: any) {
    this.$log = $log.getInstance('AppServices', false)
    this.$log.debug('constructor', this)
  }



}



/** WEBPACK FOOTER **
 ** ./src/common/services/app-services/app-services.ts
 **/